import { ReactElement, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '~/components';
import { BaseModeMessageContainer } from '../styles';
import { ReactComponent as ConnectivityOutHoursImage } from '../../../../assets/img/remoteControl/connectivityOutHours.svg';
import { ModalMachineOpeningHours } from '~/components/ModalsRemoteControl/MachineOpeningHours';

interface OutOfScheduleContentProps {
  automationIntervals: { startTime: string; endTime: string }[];
}

export function OutOfScheduleContent({
  automationIntervals,
}: OutOfScheduleContentProps): ReactElement {
  const { t } = useTranslation();
  const [openModal, setOpenModal] = useState(false);

  function onCloseModal() {
    setOpenModal(false);
  }

  function onClickOpenModal() {
    setOpenModal(true);
  }

  return (
    <>
      <ModalMachineOpeningHours
        interval={automationIntervals[0]}
        onClose={onCloseModal}
        isOpen={openModal}
      />
      <BaseModeMessageContainer data-testid="out-schedule-container">
        <div>
          <ConnectivityOutHoursImage
            style={{ height: '120px', width: '120px' }}
          />
        </div>
        <h2>{t('maquinaEstaForaFuncionamento')}</h2>
        <div style={{ flexDirection: 'column', maxWidth: '310px', gap: '8px' }}>
          <p>{t('maquinaEstaForaFuncionamentoInfo')}</p>
          <Button
            variant="rc-blue"
            style={{
              maxWidth: '96px',
              fontSize: '11px',
              padding: '8px 12px',
              borderRadius: '4px',
              letterSpacing: '0',
            }}
            onClick={onClickOpenModal}
          >
            {t('verDetalhes')}
          </Button>
        </div>
      </BaseModeMessageContainer>
    </>
  );
}
